import React from 'react'
import Link from 'next/link'
import Background, { type CategoryDirectoryBackgroundKey } from './Background'
import classes from './Card.module.css'

export interface CategoryDirectoryCardProps {
    title: string
    href: string
    background: CategoryDirectoryBackgroundKey
}

export default function Card({ title, href, background }: CategoryDirectoryCardProps) {
    return (
        <Link href={href} className={classes.card} prefetch={false} data-category-directory-background={background}>
            <Background background={background} />
            <span className={classes.title}>{title}</span>
        </Link>
    )
}
